require("../../node_modules/hammerjs/hammer.min.js");
require("../../node_modules/reflex_libs/src/lib/shape.js");
require("./pixi-spine.js");
require("../../node_modules/reflex_libs/src/lib/gsap.min.js");
require("./LoaderController.js");
require("./game.js");
require("./CascadingReels/spinFunctions.js");
require("./CascadingReels/cascadeInfiniReels.js");
require("./CascadingReels/gameReelManager.js");
require("./CascadingReels/gameSlotMachine.js");
require("./gameController.js");
require("./ParticleController.js");
require("./Feature/FreeSpins/freespinsController.js");
require("./Feature/FreeSpins/FreeSpinsSpinButtonComponent.js");
require("./Feature/FreeSpins/FreeSpinsSkipButtonComponent.js");
require("./Feature/FreeSpins/FreeSpinsDialogView.js");
require("./Feature/GambleSpin/GambleToggleView.js");
require("./GameHelpers.js");
require("../../node_modules/reflex_libs/src/lib/screenDimObject.js");
require("../../node_modules/reflex_libs/src/lib/screenshotAnimator.js");
require("./CascadingReels/dropSymbolAnimator.js");
require("./Feature/GambleSpin/GambleIntroView.js");
require("./Feature/GambleSpin/GambleDisclaimerComponent.js");
require("./Feature/GambleSpin/GambleSpinController.js");
require("./AudioController.js");
require("./ShowReelView.js");
require("./UI/GameSlamStopButtonComponent.js");
require("./BigWinController.js");
require("../../node_modules/reflex_libs/src/lib/colourBox.js");
require("./Feature/GambleSpin/ArrowComponent.js");
require("./GameHelpPageController.js");
require("./Animations/MultiplierViewLeft.js");
require("./Animations/MultiplierViewRight.js");
require("./Animations/ExtraLifeAnimsView.js");
require("./TrailComponent.js");
require("./Animations/FrameArrowsAnimsView.js");
require("./UI/LuckyBetToggleController.js");
require("./Feature/FreeSpins/FreeSpinsMeterComponent.js");
require("../../node_modules/reflex_libs/src/lib/spine.js");
require("./UI/StakeMinusButtonComponent.js");
require("./UI/StakePlusButtonComponent.js");
require("./GamePayTable.js");
require("./WinlineBatcherLowWinController.js");
require("./allWaysPayWinAnimator.js");
require("./WinTextController.js");
require("./BuyBonus/BuyBonusButtonComponent.js");
require("./BuyBonus/BuyBonusPopupView.js");
require("./UI/SettingsMenuController.js");
require("./UI/SettingsMenuButtonComponent.js");
require("./Animations/BackgroundAnimsView.js");
require("./Animations/Spine/MinerView.js");
require("./UI/GameSkipWinsButtonComponent.js");

//Setting Menu Buttons
require("./SystemSettings/SystemSettingVolumeButtonComponent.js");
require("./SystemSettings/SystemSettingsButtonComponent.js");
require("./SystemSettings/SystemSettingsCloseComponent.js");
require("./SystemSettings/SystemSettingsIntroScreenButtonComponent.js");
require("./SystemSettings/SystemSettingsSoundsComponents.js");
require("./SystemSettings/SystemSettingsBoxView.js");

//Stake/Bet Menu
require("./StakeSettings/stakeSelectionPopup_ext.js");

//Autoplay
require("./AutoplaySettings/autoplayManager-ext.js");

//Menubar
require("./SideMenu/SideMenuCloseComponent.js");
require("./SideMenu/SideMenuHelpComponent.js");
require("./GameRecoveryController.js");
